import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';

export const BsTimePickerFormControl = props => {
    // todo: fix the times in the db, 
    const times = props.times || ['12:00am', '12:30am', '1:00am', '1:30am', '2:00am', '2:30am', '3:00am', '3:30am', '4:00am', '4:30am', '5:00am', '5:30am', '6:00am', '6:30am', '7:00am', '7:30am', '8:00am', '8:30am', '9:00am', '9:30am', '10:00am', '10:30am', '11:00am', '11:30am', '12:00pm', '12:30pm', '1:00pm', '1:30pm', '2:00pm', '2:30pm', '3:00pm', '3:30pm', '4:00pm', '4:30pm', '5:00pm', '5:30pm', '6:00pm', '6:30pm', '7:00pm', '7:30pm', '8:00pm', '8:30pm', '9:00pm', '9:30pm', '10:00pm', '10:30pm', '11:00pm', '11:30pm', '11:59pm'];

    const timeOptions = times.map((time) =>
        <option key={time} value={time}>{time}</option>
    );

    return (
        <FormControl componentClass="select"
            placeholder="Select Time"
            onChange={props.onChange}
            value={props.value}
            name={props.fieldName}
        >
            {timeOptions}
        </FormControl>
    );
};

BsTimePickerFormControl.propTypes = {
    fieldName: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
};
BsTimePickerFormControl.defaultProps = {
    colSize: 6,
    readOnly: false,
    disabled: false
};

export class BsValidation extends Component {
    static getFieldValidationState = function (key, errorResult) {
        if (getErrorForKey(key, errorResult) !== undefined) {
            return 'error';
        }
    }

    // Note: key lookup is not case sensitive
    static getFieldValidationText = function (key, errorResult) {
        var error = getErrorForKey(key, errorResult);
        if (error !== undefined) {
            return error.errorMessage;
        }
    }
}

function getErrorForKey(key, errorResult) {
    if (errorResult === undefined) {
        return;
    }

    var errorMessage = '';
    try {
        errorMessage = errorResult.errors.find(function (element) {
            return element.key.toLowerCase() === this.toLowerCase();
        }, key);
    }
    catch (e) {
        return;
    }

    return errorMessage;
}



// WEBPACK FOOTER //
// ./src/components/shared/bsHelper.js